import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../UpdateCustomerInfo/components/SectionTitle';
import UpdateCustomerInfo from '../UpdateCustomerInfo/components/UpdateCustomerInfo';

const ExpiredCard = props => (
  <UpdateCustomerInfo {...props}>
    <SectionTitle>Update CC Details</SectionTitle>
    <p>Hey {props.customerName}! The credit card that you have on file for
      your membership with {props.brandName} is set to expire soon.
      To ensure that there is no interruption on your member account, you can use
      this easy form to update your payment details.
    </p>
    <br />
    <p>If you would like to wait, you can always ask the folks at {props.brandName} to
      help you update your membership during your next visit.
      Once your payment details are up to date, your membership will automatically continue.
    </p>
  </UpdateCustomerInfo>
);

ExpiredCard.propTypes = {
  customerName: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
};

export default ExpiredCard;



// WEBPACK FOOTER //
// ./src/app/membership/ExpiredCard/ExpiredCard.jsx